/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Original_Streams_HeadingInputs */



/**
* | output |
* | --- |
* | "Original streams" |
*
* @param {Audio_Embed_Export_Original_Streams_HeadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_original_streams_heading = /** @type {((inputs?: Audio_Embed_Export_Original_Streams_HeadingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Original_Streams_HeadingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Flux originaux")
	if (locale === "de") return /** @type {LocalizedString} */ ("Original-Streams")
	if (locale === "it") return /** @type {LocalizedString} */ ("Streaming originali")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Оригинальные трансляции")
	if (locale === "es") return /** @type {LocalizedString} */ ("Transmisiones originales")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("原始流媒体")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オリジナルストリーム")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मूल स्ट्रीम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Transmissões originais")
	return /** @type {LocalizedString} */ ("Original streams")
});